// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2Qnr4 .MuiInputBase-input {\n  padding-top: unset;\n  padding-bottom: unset;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_2Qnr4"
};
export default ___CSS_LOADER_EXPORT___;
